import React from 'react'
import { Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing }) => {
  const removeScrollbars = {
    '-ms-overflow-style': 'none', // IE 10+
    overflow: '-moz-scrollbars-none', // Firefox
    '&::-webkit-scrollbar': {
      display: 'none' // Safari and Chrome
    }
  }

  return {
    root: {
      overflowY: 'auto',
      overflowX: 'hidden',
      ...removeScrollbars
    },
    content: {
      marginBottom: spacing(3)
    }
  }
})

const LpqBodyContainer = props => {
  const classes = useStyles(props)
  const { children } = props

  return (
    <Grid
      container
      item
      direction='column'
      alignItems='center'
      wrap='nowrap'
      classes={{ root: classes.root }}
    >
      <Grid
        container
        item
        direction='column'
        alignItems='center'
        wrap='nowrap'
        classes={{ root: classes.content }}
      >
        {children}
      </Grid>
    </Grid>
  )
}

export default LpqBodyContainer
